import { Button, Table, Tag } from "antd";
import React from "react";
import { Card, CardBody } from "reactstrap";
import { fetchInventoryCategories } from "../../../../../api/inventory.api";
import styles from "./styles.module.scss";
import AddCategoryDialog from "./form";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

const InventoryCategory = () => {
  const [categories, setCategories] = React.useState([]);
  const [showCategoryDialog, setShowCategoryDialog] = React.useState(false);

  const getCategories = React.useCallback(async () => {
    try {
      const categories = await fetchInventoryCategories();
      setCategories(
        categories.sort((a, b) => {
          return a.id - b.id;
        })
      );
    } catch (error) {
      console.log(error);
    }
  }, []);

  React.useEffect(() => {
    getCategories();
  }, [getCategories]);

  const tableColumns = React.useMemo(() => {
    const columns = [
      {
        key: "id",
        title: "S. No.",
        dataIndex: "id",
      },
      {
        key: "category_name",
        title: "Category Name",
        dataIndex: "category_name",
      },
      {
        key: "actions",
        title: "Actions",
        render: (subCategory) => {
          return (
            <div className={styles.actions}>
              <Tag color="blue">
                <EditOutlined />
              </Tag>
              <Tag color="red">
                <DeleteOutlined />
              </Tag>
            </div>
          );
        },
      },
    ];

    return columns;
  }, []);

  return (
    <div className={styles.container}>
      <AddCategoryDialog
        onClose={() => setShowCategoryDialog(false)}
        open={showCategoryDialog}
        refresh={getCategories}
      />
      <div>
        <Card>
          <CardBody>
            <div className={styles.header}>
              <h5>Categories</h5>
              <div className={styles.actions}>
                <Button onClick={() => setShowCategoryDialog(true)}>
                  Add Category
                </Button>
              </div>
            </div>
            <div className={styles.categories}>
              <Table
                columns={tableColumns}
                dataSource={categories}
                pagination={false}
              />
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default InventoryCategory;
